import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import { ConfigInterface } from "./types";

export default createWidget<ConfigInterface>({
  type: "opendash-widget-hgoverview",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  /*
  dataItems: {
    select: "source",
    min: 1,
    max: 1,
  },
*/
  presets: [
    {
      label: "greis:widgets.overview.title",
      description: "greis:widgets.overview.description",
      imageLink: require("./preset.png"),
      tags: ["H&G"],
      widget: {
        config: {},
      },
    },
  ],
});
